import { Component } from '@angular/core';

@Component({
    selector: 'app-publications',
    templateUrl: './publications.component.html',
    styleUrl: './publications.component.scss',
    standalone: false
})
export class PublicationsComponent {

}
